import { render, staticRenderFns } from "./ViolationUpdateDialog.vue?vue&type=template&id=4c06b7d1"
import script from "./ViolationUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ViolationUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports